define(['jquery',
		 'underscore',
		 'marketplace/components/country_info',
		 'stache!marketplace/tpl/country_state_option'
], function(jQuery, _, CountryInfo, OptionTpl) {

	var countryToState = {};

	var buildCountryMap = function() {
		if(CountryInfo && _.isEmpty(countryToState)) {
			_.each(CountryInfo, function(countryObj) {
				countryToState[countryObj.country] = countryObj.states;
			});
		}
	};

	var getState = function(countryCode) {
		if (!countryCode) return [];
		// if the country to state map has not been created yet
		if (_.isEmpty(countryToState)) {
			// if the map has not been created yet, try to build it again then when it tries to find the countryCode
			// in the map, if it does, great, if it doesn't it will return an empty list
			buildCountryMap();
		}

		var states = countryToState[countryCode];
		if(_.isUndefined(states)) {
			return [];
		} else {
			return states;
		}
	};

	var renderCountries = function($parent, defaultCountry) {
		var $select = $parent.find('select');
		$select.empty();

		// Set-up our default disabled entry
		var $basic = jQuery(OptionTpl({
			value: '',
			display: 'Country'
		}));

		$basic.attr('selected', true);
		$basic.attr('disabled', true);
		$select.append($basic);

		_.each(CountryInfo, function(c) {
			if(['Everywhere Else', 'Rest of World'].indexOf(c['display-country']) === -1) {
				$select.append(OptionTpl({
					value: c['country'],
					display: c['display-country']
				}));
			}
		});

		// Select a default
		if(defaultCountry) {
			$select.val(defaultCountry);
		}
	};

	var renderStates = function($parent, states) {
		var $select = $parent.find('select');
		$select.empty();

		if(states.length === 0) {
			$parent.hide();
			$select.attr('required', false);

			return;
		}

		$parent.show();
		$parent.attr('required', true);

		// Set-up our default disabled entry
		var $basic = jQuery(OptionTpl({
			value: '',
			display: 'State'
		}));
		$basic.attr('selected', true);
		$basic.attr('disabled', true);
		$select.append($basic);

		_.each(states, function(s) {
			$select.append(OptionTpl({
				value: s['state'] || s['display-state'],
				display: s['display-state']
			}));
		});
	};

	// Renders the country/state information
	var renderForm = function($countryParent, $stateParent, defaultCountry) {
		renderCountries($countryParent, defaultCountry);

		var $country = $countryParent.find('select');
		$country.change(function() {
			var country = $country.val();
			var states = getState(country);

			renderStates($stateParent, states);
		});

		buildCountryMap();

		if(defaultCountry) {
			var states = getState(defaultCountry);
			renderStates($stateParent, states);
		}
	};

	return {
		renderForm: renderForm,
		renderCountries: renderCountries,
		renderStates: renderStates,
		getState: getState
	};
});
